"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mongoose_1 = require("mongoose");
const Polygon = new mongoose_1.Schema({
    type: {
        type: String,
        enum: ['Polygon', 'MultiPolygon'],
        required: true
    },
    coordinates: {
        type: Array,
        required: true
    }
});
exports.Polygon = Polygon;
const Feature = new mongoose_1.Schema({
    type: {
        type: String,
        enum: ['Feature'],
        required: true
    },
    properties: Object,
    geometry: Polygon
});
exports.Feature = Feature;
Feature.index({ geometry: '2dsphere' });
const FeatureCollection = new mongoose_1.Schema({
    type: {
        type: String,
        enum: ['FeatureCollection'],
        required: true
    },
    features: [Feature]
});
exports.FeatureCollection = FeatureCollection;
//# sourceMappingURL=GeoJSON.js.map